/**
 * The two scheduled imports that carry a published product to the shop.
 *
 * A supplier submits, and nothing visible happens until the PIM import writes
 * the product and the price import writes its prices. When a supplier asks why
 * their product is not on sale, this is the first thing to look at — hence its
 * place at the top of the screen, above the supplier picker: the jobs are
 * account-wide, and one run covers every supplier at once.
 */
define('portalImportsView',[
  'module',
  'marionette',
  'underscore',
  'app',
  'jquery',
  'dateUtils',
  'template!portalImportsTpl',
  'entities/suppliers/portal_imports'
], function (
  Module,
  Marionette,
  _,
  App,
  $,
  DateConverter,
  importsTpl
) {
  'use strict';

  Module.exports = Marionette.ItemView.extend({
    template: importsTpl,
    className: 'portal-imports-view',

    ui: {
      run: '.js-run'
    },

    events: {
      'click @ui.run': 'onRun'
    },

    initialize: function (options) {
      this.jobs = options.jobs || [];
      this.started = {};
    },

    serializeData: function () {
      return {
        jobs: _.map(this.jobs, _.bind(this.present, this)),
        unavailable: this.jobs.length === 0
      };
    },

    /**
     * One row's worth of state.
     *
     * The two dates are kept apart on purpose: a job whose last run failed still
     * has an old success date, and showing only that would present a broken
     * import as a healthy one.
     */
    present: function (job) {
      var labels = {
        price: _.i18n('portalImports.price', null, 'Price import'),
        pim: _.i18n('portalImports.pim', null, 'PIM import')
      };

      return {
        key: job.key,
        label: labels[job.key] || job.key,
        name: job.name,
        scheduled: !!job.name,
        schedule: job.schedule,
        lookedFor: job.lookedFor,
        failing: job.status === 'failed',
        lastSuccess: this.when(job.lastSuccess),
        lastError: this.when(job.lastError),
        started: this.started[job.key] === true
      };
    },

    when: function (value) {
      return value ? DateConverter.toMDYHHMMFormat(value) : null;
    },

    onRun: function (event) {
      var key = $(event.currentTarget).data('key');
      var $button = $(event.currentTarget);

      $button.prop('disabled', true);
      this.$('.js-error').text('');

      $.when(App.request('portal-imports:run', key))
        .done(_.bind(function () {
          // "Started", not "done": the scheduler accepts the run and answers
          // before the import has read anything. The dates below still show the
          // previous run until this one finishes, which is the truth.
          this.started[key] = true;
          this.render();
        }, this))
        .fail(_.bind(function () {
          $button.prop('disabled', false);
          this.$('.js-error').text(_.i18n('portalImports.runFailed', null,
            'Could not start that import. Try again in a moment.'));
        }, this));
    }
  });
});

